import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-card-field',
  templateUrl: './card-field.component.html',
  styleUrls: []
})
export class CardFieldComponent {

  @Input() parentGroup!: FormGroup;
  @Input() fieldName?: string;
  @Input() title?: string;
  @Input() inputMode?: string;
  @Input() pattern?: string;
  @Input() largeSpacing?: boolean;
}
